// extracted by mini-css-extract-plugin
export var heroImage = "_dh-1";
export var modal = "_dh-0";